import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { SectionLayoutMetadata, SectionLayoutMetadataBase } from '../../../model/dyn-form/form-metadata/layout/section-layout.model';
import { EFormSectionModelValueResponse, EFormViewSection } from '../../../model/eform/eform-api.model';
import { DynFormSection } from '../../../model/dyn-form/dyn-form-section.model';
import { ProcedureInstanceBase } from '../../../model/procedure-instance/procedure-instance.model';
import { EFormDynamicSectionMetadataService } from '../../../services/eform/e-form-dynamic-section-metadata.service';
import { EFormValueService } from '../../../services/eform/e-form-value.service';
import { CommonModule } from '@angular/common';
import { DynamicViewRowLayoutComponent } from './dynamic-view-row-layout/dynamic-view-row-layout.component';
import { DynamicViewRepeatLayoutComponent } from './dynamic-view-repeat-layout/dynamic-view-repeat-layout.component';
import { LayoutTypeMetadata } from '../../../model/dyn-form/form-metadata/layout-type-metadata.enum';
import { RowLayoutMetadataBase } from '../../../model/dyn-form/form-metadata/layout/row-layout.metadata.model';
import { ItemTypeMetadata } from '../../../model/dyn-form/form-metadata/item-type-metadata.enum';
import { HasShowHideLogic } from '../../../model/dyn-form/form-metadata/logic/has-show-hide-logic.model';
import { ItemMetadataBase } from '../../../model/dyn-form/form-metadata/item/item-metadata.model';
import { ShowHideLogicMetadataBase } from '../../../model/dyn-form/form-metadata/logic/show-hide-logic-metadata.model';
import { LayoutMetadataBase } from '../../../model/dyn-form/form-metadata/layout/layout-metadata.model';
import { RepeatLayoutMetadataBase } from '../../../model/dyn-form/form-metadata/layout/repeat-layout-metadata.model';
import { DynamicViewWebserviceLayoutComponent } from './dynamic-view-webservice-layout/dynamic-view-webservice-layout.component';


@Component({
    selector: 'app-dynamic-view-section',
    templateUrl: './dynamic-view-section.component.html',
    styleUrls: ['./dynamic-view-section.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        DynamicViewRowLayoutComponent, DynamicViewRepeatLayoutComponent, DynamicViewWebserviceLayoutComponent
    ]
})
export class DynamicViewSectionComponent implements EFormViewSection, OnInit {

    metadata!: SectionLayoutMetadata
    modelData: any

    fieldVisibility: Map<string, boolean> = new Map()

    constructor(
        @Inject("CONTAINER_DATA") public data: { section: DynFormSection, procedureInstance: ProcedureInstanceBase, isAllSectionsLoaded: (sectionId: number) => void }, 
        protected dynSectionMetadata: EFormDynamicSectionMetadataService, protected eFormValueService: EFormValueService,
        private readonly changeDetectorRef: ChangeDetectorRef
    ) {

    }

    sectionId(): number {
        return this.data.section.id
    }

    ngOnInit(): void {

        forkJoin<[SectionLayoutMetadata, EFormSectionModelValueResponse]>([
            this.dynSectionMetadata.loadSectionMetadata(this.data.section.id),
            this.eFormValueService.getEFormSectionModelValue(this.data.procedureInstance.serviceInstanceId, this.data.procedureInstance.id, this.data.section.id)
        ]).subscribe(r => {

            if (r[1].ok == false) {
                //DO SOMETHING
                return
            }

            this.metadata = r[0];
            this.metadata.onFormCreation = false
            this.modelData = r[1].entity.value

            if (this.modelData == null) {
                this.modelData = SectionLayoutMetadataBase.getDefaultValue(this.metadata)
            }

            for (let item of this.metadata.items) {
                
                if (item.type == LayoutTypeMetadata.Row) {

                    for (let rowItem of (<RowLayoutMetadataBase>item).items) {

                        if (rowItem.type == ItemTypeMetadata.CheckBox || rowItem.type == ItemTypeMetadata.MultiCheckBox || rowItem.type == ItemTypeMetadata.Radio || rowItem.type == ItemTypeMetadata.Select) {

                            let itemLogic = <HasShowHideLogic & ItemMetadataBase> rowItem

                            if (ShowHideLogicMetadataBase.hasAnyValue(itemLogic.logicShowHideField) == false) {
                                continue
                            }

                            this.checkFieldVisibility(itemLogic)

                        }

                    }

                }

            }
            
            this.changeDetectorRef.detectChanges()
            this.data.isAllSectionsLoaded(this.data.section.id)

        })

    }

    checkFieldVisibility(item: HasShowHideLogic & ItemMetadataBase) {

        item.logicShowHideField.forEach(l => {

            if (l.ref == null) {
                return
            }

            let val = this.modelData[item.fieldName]
            if (item.type == ItemTypeMetadata.MultiCheckBox && val != undefined) {
                val = val[<string> l.value]
            }

            if ((item.type == ItemTypeMetadata.MultiCheckBox && val) || val == l.value) {
                this.fieldVisibility.set(<string> l.ref, true)
            } else {
                this.fieldVisibility.set(<string> l.ref, false)
            }

        })

    }

    isVisible(item: LayoutMetadataBase): boolean {
        if (item instanceof RepeatLayoutMetadataBase) {
            return this.fieldVisibility.get(item.fieldName) ?? true
        }
        return true // Don't use this method if item is not RepeatLayout or TableLayout //
    }

}
